<!-- Popup édition évaluations liée à une catégorie -->
<div>
  <div></div>
  <table class="uk-table uk-table-small uk-table-divider">
    <thead>
      <tr>
        <th>{{ 'testeur' | uppercase }}</th>
        <th>{{ 'résultat' | uppercase }}</th>
        <th>{{ 'date' | uppercase }}</th>
        <th>{{ 'expiration' | uppercase }}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <kendo-dropdownlist
            [data]="infohabilitation.evaluateurs"
            [textField]="'libelle'"
            [valueField]="'id'"
            [valuePrimitive]="true"
            [(ngModel)]="categorie.evaluateur"
          >
          </kendo-dropdownlist>
        </td>
        <td>
          <kendo-dropdownlist
            [data]="_config.resultats.dataSource"
            [textField]="'libelle'"
            [valueField]="'code'"
            [valuePrimitive]="true"
            [(ngModel)]="categorie.resultat"
          >
          </kendo-dropdownlist>
        </td>
        <td>
          <kendo-datepicker [format]="'dd/MM/yyyy'" class="dateAppJust" [(ngModel)]="categorie.date"></kendo-datepicker>
        </td>
        <td>
          <kendo-datepicker
            [format]="'dd/MM/yyyy'"
            class="dateAppJust"
            [(ngModel)]="categorie.dateExpiration"
          ></kendo-datepicker>
        </td>
      </tr>
      <td class="uk-margin-small-top">
        <kendo-numerictextbox [(ngModel)]="categorie.duree" [value]="0" [min]="0" [max]="999"> </kendo-numerictextbox>
      </td>
      <td class="align-text">
        <p>minutes</p>
      </td>
    </tbody>
  </table>

  <!-- bloc des notes pratique -->
  <div class="uk-card uk-card-default uk-margin-medium-bottom">
    <div class="uk-card-header uk-padding-small uk-background-muted">
      <div class="uk-width-expand">
        <h3 class="uk-card-title uk-margin-remove-bottom uk-text-meta uk-text-uppercase uk-text-muted">
          {{ 'note(s) pratique(s)' | titlecase }}
        </h3>
      </div>
    </div>

    <table class="uk-table uk-table-small uk-table-divider">
      <thead>
        <tr>
          <th>{{ 'libelle' | titlecase }}</th>
          <th>{{ 'note' | titlecase }}</th>
          <th>{{ 'echec a un theme éliminatoire' | titlecase }}</th>
          <th>{{ 'statut' | titlecase }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let eval of categorie.evaluations; let i = index">
          <td>
            <p>{{ getNote('libelle', eval.note) }}</p>
          </td>
          <td>
            <p>
              <kendo-numerictextbox [(ngModel)]="eval.valeur" [value]="0" [min]="0" [max]="999"> </kendo-numerictextbox>
              /100
            </p>
            Seuil de reussite {{ getNote('seuil_reussite', eval.note) || '-' }}
          </td>
          <td>
            {{ getNote('theme_eliminatoire', eval.note) === true ? 'oui' : 'Non' }}
          </td>
          <td>
            <kendo-dropdownlist
              [data]="_config.statuts.dataSource"
              [textField]="'libelle'"
              [valueField]="'code'"
              [valuePrimitive]="true"
              [(ngModel)]="eval.statut"
            >
            </kendo-dropdownlist>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div>
  <button kendoButton (click)="valider()" class="k-button k-primary float-right">Valider</button>
</div>
